export enum TipoCampoSpecificoEnum {
  LIBERO = <any>"LIBERO",
  ANAGRAFICA_MANUALE = <any>"ANAGRAFICA_MANUALE",
  ANAGRAFICA_ESTERNA = <any>"ANAGRAFICA_ESTERNA",
}
